import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RibbonModule} from '../../ribbon/ribbon.module';
import {TreeviewModule} from '../../treeview/treeview.module';
import {EmailComposerComponent} from './email-composer.component';
import {GenericModalModule} from '../../modal/generic-modal.module';
import {CreateObjectDialogModule} from '../../createObjectDialog/create-object-dialog.module';
import {FormsModule} from '@angular/forms';
import {ContentPreviewPaneModule} from '../../content-preview-pane/content-preview-pane.module';
import {EmailModule} from '../email/email.module';
import {SendTestEmailModule} from '../emailTest/send-test-email.module';

@NgModule({
    imports: [
        CommonModule, RibbonModule, TreeviewModule, GenericModalModule, CreateObjectDialogModule, FormsModule, ContentPreviewPaneModule, EmailModule, SendTestEmailModule
    ],
    declarations: [EmailComposerComponent],
    providers: [],
    exports: [EmailComposerComponent]
})
export class EmailComposerModule {}
